<template>
    <div class="page have-menu no-bg">
        <div class="bg-fixed bg-splus"></div>
        <div class="page-content">
            <TopBar></TopBar>
            <div class="grid grid-cols-3 text-center text-20 text-gray-1 pt-4 px-4">
                <div class="py-1" @click="clickTab('burn')" :class="{'text-green-1 border-b-4 border-green-1': historyType == 'burn'}">การใช้คะแนน</div>
                <div class="py-1" @click="clickTab('earn')" :class="{'text-green-1 border-b-4 border-green-1': historyType == 'earn'}">การรับคะแนน</div>
                <div class="py-1" @click="clickTab('point')" :class="{'text-green-1 border-b-4 border-green-1': historyType == 'point'}">คะแนนหมดอายุ</div>
            </div>
            <div class="pt-5 px-3" v-show="historyType == 'burn'">
                <HistoryList
                    ref="history-list"
                    :initListConfig="purchaseListConfig"
                    :initFilterConfig="purchaseFilterListConfig"
                    :modalController="modalController"
                ></HistoryList>
            </div>
            <div class="pt-5 px-3" v-show="historyType == 'earn'" >
                <DatePickerDropdownEarn
                    v-model:inputValue="objEarn.dateEarn"
                    :inputLbl="lbl.history.historyDate"
                    @onDateChange="onSelectDate($event)"
                ></DatePickerDropdownEarn>
                <HistoryEarnList v-if="earnpointListConfig"
                    ref="earn-list"
                    :initListConfig="earnpointListConfig"
                    :modalController="modalController"
                ></HistoryEarnList>
            </div>
            <div class="pt-5 px-3 " v-if="historyType == 'point'" >
                <Expiring></Expiring>
            </div>
            <MenuBar :modalController="modalController"></MenuBar>
        </div>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
import ConfigManager from '@/config/ConfigManager.js';
//component
import TopBar from '@/components/Layout/TopBar/TopBar.vue';
import HistoryList from '../component/HistoryList.vue';
import HistoryEarnList from '../component/HistoryEarnList.vue';
import MenuBar from "@/components/Layout/MenuBar/MenuBar.vue";
import DatePickerDropdownEarn from "@/components/Input/label/DatePickerDropdownEarn.vue";
import Expiring from "../component/Expiring.vue";
//mixin
import AuthPageMixin from '@/mixin/AuthPageMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
//service
import {
    PurchaseListConfigBuilder,
    PurchaseFilterConfigBuilder,
} from '@/core/History/config/HistoryConfigModel.js';
import { HistoryPointConfigBuilder } from '@/core/Point/config/PointConfigModel';

export default {
    name: 'History',
    mixins: [ModalMixin, AuthPageMixin, LocaleMixin],
    components: {
        TopBar,
        HistoryList,
        HistoryEarnList,
        MenuBar,
        DatePickerDropdownEarn,
        Expiring
    },
    data: function() {
        return {
            purchaseListConfig: null,
            purchaseFilterListConfig: null,
            historyType: 'burn',

            objEarn: {
                dateEarn: null
            },
            earnpointListConfig: null,
        };
    },
    created: function() {
        this.setScrollLoadMore();
        this.setupHistoryList();

        this.tracking.screenName('point_history');
        this.tracking.event('point_history', 'view_point_history');
    },
    beforeUnmount: function() {
        window.onscroll = null;
    },
    methods: {
        //#region mixin
        onSetupModalCompleted: function() {
            this.initialHistoryModal();
        },
        //#endregion mixin
        clickTab: function (tab) {
            if(tab == 'burn') {
                this.tracking.event('burn', 'click_burn');
            } else if(tab == 'earn') {
                this.tracking.event('earn', 'click_earn');
            } else {
                this.tracking.event('expired', 'click_expired');
            }
            this.historyType = tab;
            setTimeout(()=> {
                this.reInit();
            },300);
        },
        onSelectDate: async function (obj) {
            this.objEarn.dateEarn = obj.formated;
            if (this.earnpointListConfig) {
                this.setupEarnPointList();
                await this.$refs['earn-list'].reinitList(this.earnpointListConfig);
            } else {
                this.setupEarnPointList();
            }

        },
        reInit: async function () {
            this.loadingModal.show();
            if (this.historyType == 'burn') {
                this.setupHistoryList();
                await this.$refs['history-list'].reinitList(this.purchaseListConfig,this.purchaseFilterListConfig);
            } else if (this.historyType == 'earn') {
                this.setupEarnPointList();
                await this.$refs['earn-list'].reinitList(this.earnpointListConfig);
            }
            this.loadingModal.hide();
        },
        setScrollLoadMore: function() {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                let scrollOffSet = 100;
                let pageHeight = Math.max(
                    window.scrollY,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                let bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    this.loadMore();
                }
            };
        },
        setupHistoryList: async function () {
            //initial config for api.
            let listConfig = new PurchaseListConfigBuilder()
                .setConfigList(ConfigManager.getHistoryPurchaseList())
                .setTop(25)
                .create();
            this.purchaseListConfig = listConfig;

            //initial filter config for api.
            let filterListConfig = new PurchaseFilterConfigBuilder()
                .create();
            this.purchaseFilterListConfig = filterListConfig;
        },
        setupEarnPointList: function () {
            let earnpointListConfig = new HistoryPointConfigBuilder()
                .setType('earn')
                .setMonth(this.objEarn.dateEarn)
                .create()

            this.earnpointListConfig = earnpointListConfig;
        },
        loadMore: async function() {
            if (this.historyType == 'burn') {
                await this.$refs['history-list'].loadMore();
            } else if (this.historyType == 'earn') {
                await this.$refs['earn-list'].loadMore();
            }
        },
    },
}
</script>
